import { emailRegex } from '../../../utils';
import { isCorrectPhoneNumber } from '../../../PhoneInput/utils';

type ValidationFunction<value> = (value: value) => string | undefined;

const requiredField = <value>(value: value) => (typeof value === 'undefined' ? 'Required' : undefined);

const onlyLetters = (value: string) => (value.match(/\d/gi) ? 'Only letters' : undefined);

export const useRequestFormValidation = () => {
	const validateName: ValidationFunction<string> = value => {
		let testResult = undefined;

		for (const testFunc of [requiredField, onlyLetters]) {
			testResult = testFunc(value);

			if (testResult) {
				break;
			}
		}

		return testResult;
	};

	const validateComments: ValidationFunction<string> = value => {
		return undefined;
	};

	const validateEmail: ValidationFunction<string> = value => {
		let testResult = undefined;

		for (const testFunc of [requiredField]) {
			testResult = testFunc(value);

			if (testResult) {
				break;
			}

			if (!emailRegex.test(value)) {
				return 'Wrong email';
			}
		}

		return testResult;
	};

	const validatePhone: ValidationFunction<string> = value => {
		let testResult = undefined;

		for (const testFunc of [requiredField]) {
			testResult = testFunc(value);

			if (testResult) {
				break;
			}

			if (!isCorrectPhoneNumber(value)) {
				return 'Wrong phone';
			}
		}

		return testResult;
	};

	const validateAgreeButton: ValidationFunction<boolean> = requiredField;

	return {
		validateName,
		validateEmail,
		validatePhone,
		validateComments,
		validateAgreeButton
	};
};
